
export class FormatHelpers {
    static numberToString(value: number): string {
        return value.toLocaleString('en-US', { maximumFractionDigits: 2, minimumFractionDigits: 2 });
    }
}